<template>
    <v-list-group
        v-if="visibleChildren.length"
        v-model="open"
        :prepend-icon="item.icon"
        class="sidebar-menu-group"
        :class="{ 'sidebar-menu-group--active': hasActiveChild }"
        no-action
    >
        <template v-slot:activator>
            <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
        </template>

        <MenuItem
            v-for="(child, index) in visibleChildren"
            :key="`${item.name}-${index}`"
            :item="child"
            nested
        />
    </v-list-group>
</template>

<script>
import MenuItem from "@/layouts/components/MenuItem";

export default {
    name: "MenuGroup",
    components: { MenuItem },
    props: {
        item: { type: Object, required: true },
        user: { type: Object, required: true },
    },
    data() {
        return { open: false };
    },
    computed: {
        visibleChildren() {
            return (this.item.children || []).filter(child => this.$check(this.user, child.permissions));
        },
        hasActiveChild() {
            return this.visibleChildren.some(child => this.routeMatches(child.route));
        },
    },
    watch: {
        "$route.path": {
            immediate: true,
            handler() {
                if (this.hasActiveChild) this.open = true;
            },
        },
    },
    methods: {
        routeMatches(route) {
            if (!route) return false;
            return this.$route.path === route || this.$route.path.startsWith(`${route}/`);
        },
    },
};
</script>

<style lang="scss">
.sidebar-menu-group {
    margin: 1px 4px;
}

.sidebar-menu-group > .v-list-group__header {
    border: 0;
    border-radius: 7px;
    min-height: 40px;
    padding: 0 10px !important;
    transition: background-color .14s ease;
}

.sidebar-menu-group > .v-list-group__header:hover {
    background: #f6f7f8;
}

.sidebar-menu-group > .v-list-group__header .v-list-item__icon {
    align-self: center;
    margin: 0 11px 0 0 !important;
    min-width: 18px;
}

.sidebar-menu-group > .v-list-group__header .v-icon {
    color: #7b8490;
    font-size: 18px;
}

.sidebar-menu-group > .v-list-group__header .v-list-item__title {
    color: #343a43;
    font-family: "Plus Jakarta Sans", "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 1.25;
    white-space: normal;
}

.sidebar-menu-group--active > .v-list-group__header {
    background: transparent;
}

.sidebar-menu-group--active > .v-list-group__header .v-icon,
.sidebar-menu-group--active > .v-list-group__header .v-list-item__title {
    color: #252b33;
}

.sidebar-menu-group .v-list-group__items {
    border-left: 0;
    margin: 1px 0 7px 16px;
    padding: 1px 0;
}

.sidebar-menu-group > .v-list-group__header .v-list-group__header__append-icon {
    margin-left: 6px !important;
    min-width: 18px;
}

.sidebar-menu-group > .v-list-group__header .v-list-group__header__append-icon .v-icon {
    color: #9aa2ab;
    font-size: 16px;
}
</style>
